(() => {
  if (window.pebbleDiceGiftLoaded) return;
  window.pebbleDiceGiftLoaded = true;
  const pending = new Set();
  const accepted = new Set();
  const requestedKey = 'tmr-dice-gift-requested';
  const seenKey = 'tmr-dice-gift-seen';
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
  const write = (storage, key) => { try { window[storage].setItem(key, '1'); } catch { /* Private browsing must not break the form. */ } };

  function bindForm(form) {
    if (form.dataset.bound || form.dataset.giftForm === 'false') return;
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-gift-status]');
    if (!input || !button || !status || !form.dataset.siteId || !form.dataset.listId) return;
    form.dataset.bound = 'true';
    button.disabled = false;
    const show = (message, failed = false) => {
      status.textContent = message;
      status.hidden = false;
      status.setAttribute('role', failed ? 'alert' : 'status');
      input.setAttribute('aria-invalid', String(failed));
    };
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const email = input.value.trim().toLowerCase();
      const key = form.dataset.listId + ':' + email;
      if (pending.has(key)) return;
      if (accepted.has(key)) {
        show('Your request is already submitted. Check your inbox, including Spam and Promotions, for your gift email.');
        return;
      }
      pending.add(key);
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      show('Sending your request...');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.siteId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
          signal: controller.signal,
          body: JSON.stringify({ data: {
            type: 'subscription',
            attributes: {
              custom_source: 'TMR Dice Gift ' + form.dataset.source,
              profile: { data: { type: 'profile', attributes: { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.listId } } },
          } }),
        });
        if (response.status !== 202) throw new Error(response.status === 429 ? 'rate-limit' : 'not-accepted');
        accepted.add(key);
        write('localStorage', requestedKey);
        show(form.dataset.successMessage || 'You’re on the list! Your personal gift code will arrive by email shortly. Check Spam and Promotions too. Already requested a code? Please use your original gift email.');
      } catch (error) {
        show(error.name === 'AbortError'
          ? 'The connection timed out. Your request may have arrived. Please check your inbox before trying again.'
          : error.message === 'rate-limit'
            ? 'Please wait a moment and try again. Your signup has not been confirmed.'
            : 'We could not confirm your signup. Please try again or email hello@themahjritual.com.', true);
      } finally {
        clearTimeout(timeout);
        pending.delete(key);
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
  }

  function bindPopup(dialog) {
    if (dialog.dataset.bound || typeof dialog.showModal !== 'function') return;
    dialog.dataset.bound = 'true';
    let timer;
    let previousFocus;
    let scrollRoot;
    let previousOverflow;
    const editor = dialog.dataset.designMode === 'true';
    const eligible = () => editor || (!read('sessionStorage', seenKey) && !read('localStorage', requestedKey));
    const open = () => {
      if (!dialog.isConnected || dialog.open || !eligible()) return;
      // Wait for the shopper's current drawer/modal to close instead of stacking dialogs.
      if (document.hidden || document.querySelector('dialog[open]')) { timer = setTimeout(open, 1000); return; }
      previousFocus = document.activeElement;
      scrollRoot = document.querySelector('.page-wrapper') || document.documentElement;
      previousOverflow = scrollRoot.style.overflowY;
      scrollRoot.style.overflowY = 'hidden';
      dialog.showModal();
      if (!editor) write('sessionStorage', seenKey);
      dialog.focus({ preventScroll: true });
    };
    dialog.querySelectorAll('[data-gift-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    let outsideDown = false;
    const outside = event => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    dialog.addEventListener('pointerdown', event => { outsideDown = event.target === dialog && outside(event); });
    dialog.addEventListener('click', event => { if (outsideDown && event.target === dialog && outside(event)) dialog.close(); outsideDown = false; });
    dialog.addEventListener('close', () => {
      if (scrollRoot) scrollRoot.style.overflowY = previousOverflow;
      const focusTarget = previousFocus?.isConnected ? previousFocus : document.body;
      // A timed popup can open before any control is focused. Body needs a temporary
      // tabindex or Escape leaves focus on the now-hidden email field in Chrome.
      const pageTarget = focusTarget === document.body || focusTarget === document.documentElement;
      const previousTabindex = focusTarget.getAttribute('tabindex');
      if (pageTarget) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({ preventScroll: true });
      if (pageTarget) {
        if (previousTabindex === null) focusTarget.removeAttribute('tabindex');
        else focusTarget.setAttribute('tabindex', previousTabindex);
      }
    });
    timer = setTimeout(open, editor ? 300 : Number(dialog.dataset.delay || 6) * 1000);
    dialog.giftCleanup = () => { clearTimeout(timer); if (dialog.open) dialog.close(); };
    dialog.giftPreview = open;
  }

  function init(root = document) {
    root.querySelectorAll('[data-gift-form]').forEach(bindForm);
    root.querySelectorAll('[data-dice-gift-popup]').forEach(bindPopup);
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-dice-gift-popup]')?.giftCleanup?.());
  document.addEventListener('shopify:section:select', event => event.target.querySelector('[data-dice-gift-popup]')?.giftPreview?.());
})();
